import { registerQuery } from 'data-fetching-client';
import { getInsightsClient } from '../../clients/insightsClient';
const INSTALL_STATS_QUERY_FIELD_NAME = 'installStats';
export const INSTALL_STATS_QUERY = registerQuery({
  fieldName: INSTALL_STATS_QUERY_FIELD_NAME,
  args: ['offeringId'],
  fetcher: ({
    offeringId
  }) => getInsightsClient('app').get(`/stats/offering-install-stats`, {
    query: {
      offeringId
    }
  })
});